import script from "./Logs.vue?vue&type=script&lang=ts&setup=true"
export * from "./Logs.vue?vue&type=script&lang=ts&setup=true"

import "./Logs.vue?vue&type=style&index=0&id=5910ca1f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5910ca1f"]])

export default __exports__